export enum CandidateTestTaskStatus {
  Passed = 'Passed',
  Failed = 'Failed',
}
